import '../css/bootstrap.min.css';
import '../css/main.css';

import title from '../vue/Title.vue';
import calculator from '../vue/Calculator.vue';
import taxbar from '../vue/TaxBar.vue';
import taxtable from '../vue/TaxTable.vue';
import feedback from '../vue/Feedback.vue';
import link from '../vue/Link.vue';
import info from '../vue/Info.vue';

import Vue from 'vue';
import { ACT_YEAR, getLang, setLang } from './main';

Vue.component('my-title', title);
Vue.component('my-calculator', calculator);
Vue.component('my-taxbar', taxbar);
Vue.component('my-taxtable', taxtable);
Vue.component('my-feedback', feedback);
Vue.component('my-link', link);
Vue.component('my-info', info);

new Vue({
  el: '#container',
  data: {
    year: ACT_YEAR,
    lang: getLang(),
    taxes: {}
  },
  watch: {
    lang: function(newLang) {
      setLang(newLang);
    }
  }
});



//////////////////
// WEBPACK FOOTER
// ./src/js/init.js
// module id = 6
// module chunks = 0